import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Container from "@mui/material/Container"
import Typography from "@mui/material/Typography"
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined"

import React, { useEffect, useState } from "react"
import { SEO } from "../../components/SEO"
import { PATHS } from "../../constants/paths"
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined"
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined"
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined"
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined"
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined"
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined"

import Grid from "@mui/material/Grid"
import { TournamentCard } from "./components/TournamentCard"
import { getTournaments } from "../../api/tournaments"
import { NavLink } from "react-router-dom"
import { useAppSelector } from "../../store"
import useMediaQuery from "@mui/material/useMediaQuery"

const summaryStats = [
  {
    icon: <EmojiEventsOutlinedIcon />,
    label: "TOTAL JACKPOT",
    value: "48,240 USDT",
  },
  {
    icon: <GroupsOutlinedIcon />,
    label: "ACTIVE PLAYERS",
    value: "1,248",
  },
  {
    icon: <AccessTimeOutlinedIcon />,
    label: "NEXT WEEKLY STARTS IN",
    value: "2D 14H 32M 18S",
  },
]

const benefits = [
  {
    icon: <MonetizationOnOutlinedIcon />,
    title: "REAL USDT REWARDS",
    text: "Win real USDT in every tournament.",
  },
  {
    icon: <SecurityOutlinedIcon />,
    title: "FAIR & TRANSPARENT",
    text: "Anti-cheat protection and fair scoring system.",
  },
  {
    icon: <AccountTreeOutlinedIcon />,
    title: "COMPETE & CLIMB",
    text: "Climb the leaderboard and prove your skills.",
  },
  {
    icon: <AutoAwesomeOutlinedIcon />,
    title: "NEW CHALLENGES",
    text: "Daily and weekly tournaments with unique modifiers.",
  },
]

const tabs = ["ALL TOURNAMENTS", "Daily", "Weekly", "Monthly"]

export const TournamentsPage = () => {
  const [tournaments, setTournaments] = useState([])
  const [activeTab, setActiveTab] = useState("ALL TOURNAMENTS")

  const isDownSm = useMediaQuery("(max-width: 600px)")
  const isDownMd = useMediaQuery("(max-width: 900px)")

  const { user } = useAppSelector((state) => state.user)

  const filteredRows =
    activeTab === "ALL TOURNAMENTS"
      ? tournaments
      : tournaments.filter((row) => row.type === activeTab)

  const handleTabChange = (tab) => {
    setActiveTab(tab)
  }

  useEffect(() => {
    loadTournaments()
  }, [user])

  const loadTournaments = async () => {
    const { success, tournaments } = await getTournaments(user?.address)

    if (success) {
      setTournaments(tournaments)
    }
  }

  return (
    <Box>
      <SEO
        title="Zombie TD | Tournaments"
        description="Compete in epic battles, survive endless zombie waves and win real USDT rewards. Join daily, weekly and monthly tournaments. Climb the leaderboard and prove you are the ultimate survivor!"
        ogTitle="Zombie TD | Tournaments"
        ogDescription="Compete in epic battles, survive endless zombie waves and win real USDT rewards. Join daily, weekly and monthly tournaments. Climb the leaderboard and prove you are the ultimate survivor!"
        ogUrl={PATHS.TOURNAMENTS.PATH}
      />
      <Box className="content">
        <Box className="content-head" mb={4} mt={2}>
          <Container fixed>
            <Box>
              <Typography variant="h1">Tournaments</Typography>

              <Typography variant="subtitle1" textAlign="left" sx={{ mb: 2 }}>
                Compete in daily, weekly, and monthly tournaments.
                <br />
                Fight endless zombie waves, earn points, climb the leaderboard,
                and win real USDT rewards.
              </Typography>
            </Box>

            {/* Summary statistics */}
            {/*<Box*/}
            {/*  sx={{*/}
            {/*    display: "inline-flex",*/}
            {/*    flexWrap: "wrap",*/}
            {/*    gap: 1.5,*/}
            {/*    mt: 3,*/}
            {/*    mb: 6,*/}
            {/*    border: "1px solid #121212",*/}
            {/*    borderRadius: 1,*/}
            {/*    background: "linear-gradient(180deg, #000 50%, #121212 100%)",*/}
            {/*  }}*/}
            {/*>*/}
            {/*  {summaryStats.map((stat) => (*/}
            {/*    <StatCard {...stat} />*/}
            {/*  ))}*/}
            {/*</Box>*/}

            {isDownSm && (
              <Button
                fullWidth
                component={NavLink}
                to={`${PATHS.TOURNAMENTS_HISTORY.PATH}`}
                sx={{
                  minWidth: "max-content",
                  color: "#aaa39a",
                  fontWeight: 900,
                  justifyContent: "end",
                  mb: 1,
                  "& svg": {
                    fontSize: 16,
                  },
                  "&:hover": {
                    color: "#d69a49",
                    background: "transparent",
                  },
                }}
              >
                Tournaments History
              </Button>
            )}

            {/* Tabs */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                mb: 2.4,
                overflowX: "auto",
                borderBottom: "1px solid #121212",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  minWidth: "max-content",
                }}
              >
                {tabs.map((tab) => {
                  const isActive = activeTab === tab
                  return (
                    <Button
                      key={tab}
                      onClick={() => handleTabChange(tab)}
                      sx={{
                        px: 2.4,
                        py: 1.15,
                        color: isActive ? "#c49654" : "#9c9284",
                        fontWeight: 900,
                        borderRadius: "4px 4px 0 0",
                        border: isActive
                          ? "1px solid rgba(198,146,76,0.45)"
                          : "1px solid transparent",
                        background: isActive
                          ? "rgba(196,150,84,0.06)"
                          : "transparent",
                        "&:hover": {
                          borderColor: "rgba(198,146,76,0.45)",
                          background: "rgba(198,146,76,0.08)",
                        },
                      }}
                    >
                      {tab}
                    </Button>
                  )
                })}
              </Box>

              {!isDownSm && (
                <Button
                  component={NavLink}
                  to={`${PATHS.TOURNAMENTS_HISTORY.PATH}`}
                  sx={{
                    minWidth: "max-content",
                    color: "#aaa39a",
                    fontWeight: 900,
                    "& svg": {
                      fontSize: 16,
                    },
                    "&:hover": {
                      color: "#d69a49",
                      background: "transparent",
                    },
                  }}
                >
                  Tournaments History
                </Button>
              )}
            </Box>

            {/* Tournaments list */}
            <Grid container spacing={2.5}>
              {filteredRows.map((tournament) => (
                <Grid key={tournament.title} item xs={12} sm={6} md={4}>
                  <TournamentCard tournament={tournament} />
                </Grid>
              ))}
            </Grid>

            {/* Benefits */}
            <Box
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  md: "row",
                },
                gap: {
                  xs: 0,
                  md: 0,
                },
                mt: 3,
                px: 0.5,
                border: "1px solid #161616",
                borderRadius: 1,
              }}
            >
              {benefits.map((benefit, index) => (
                <Box
                  key={benefit.title}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    px: 2.2,
                    my: 2,
                    flex: 1,
                    minWidth: 0,
                    borderRight: {
                      xs: "none",
                      md:
                        index !== benefits.length - 1
                          ? "1px solid rgba(198,146,76,0.16)"
                          : "none",
                    },
                    borderBottom: {
                      xs:
                        index !== benefits.length - 1
                          ? "1px solid rgba(198,146,76,0.16)"
                          : "none",
                      md: "none",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      color: "#d69a49",
                      "& svg": {
                        fontSize: 40,
                      },
                    }}
                  >
                    {benefit.icon}
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        color: "#d69a49",
                        fontWeight: 950,
                        lineHeight: 1,
                        mb: 1,
                      }}
                    >
                      {benefit.title}
                    </Typography>
                    <Typography
                      sx={{
                        mt: 0.4,
                        color: "#dedede",
                        fontSize: 16,
                        lineHeight: 1.35,
                      }}
                    >
                      {benefit.text}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  )
}
